<template>
  <div
    v-show="showSuccessModal"
    class="fixed inset-0 flex items-center justify-center bg-black/80 z-[999] px-4 backdrop-blur-sm"
  >
    <div
      class="relative w-full max-w-md bg-[#14181F] border border-gray-800 p-8 rounded-[16px] shadow-[0_10px_40px_rgba(0,0,0,0.5)] text-center"
    >
      <!-- Title -->
      <h2 class="text-2xl sm:text-3xl font-black text-[#00F0FF] font-oxanium tracking-wide uppercase mb-4 mt-2">
        {{ $t('StoreSuccessModal.Title') }}
      </h2>

      <!-- Message -->
      <p class="text-[#B9CACB] text-sm sm:text-base leading-relaxed mb-6">
        {{ $t('StoreSuccessModal.Message') }}<br />
        {{ $t('StoreSuccessModal.HereIsYourTicket') }}
      </p>

      <!-- Ticket Display -->
      <div
        class="mb-8 px-6 py-4 bg-[#0D0B10] border border-gray-800 text-[#00F0FF] font-semibold rounded-[10px] shadow-inner font-mono break-words text-sm sm:text-base tracking-widest"
      >
        {{ ticket }}
      </div>

      <!-- Close Button -->
      <div class="flex w-full">
        <button
          @click="$emit('closeSuccessModal')"
          class="w-full px-6 py-3 bg-[#00F0FF] text-black font-bold text-sm rounded-[10px] hover:bg-[#00d4e0] transition-colors uppercase tracking-wider"
        >
          {{ $t('StoreSuccessModal.Close') }}
        </button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    showSuccessModal: Boolean,
    ticket: String,
  },
};
</script>
